import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import SchoolOutlined from '@mui/icons-material/SchoolOutlined';
import { iconButtonClasses as muiIconButtonClasses } from '@mui/material/IconButton';
import { noteClasses } from './noteClasses';

export const HowToIcon = styled(SchoolOutlined, {
  name: 'AFHowToIcon'
})(({ theme }) => ({
  color: theme.palette.grape[600]
}));

const propsForStylingOnly = ['maxWidth', 'hasCloseIcon', 'isBanner'];

export const PaperRoot = styled(Paper, {
  name: 'AFNote',
  shouldForwardProp: prop => !propsForStylingOnly.includes(prop)
})(({ theme, maxWidth, hasCloseIcon, isBanner }) => ({
  ...theme.typography.body2,
  backgroundColor: isBanner
    ? theme.palette.background.paper
    : theme.palette.grey[50],
  display: 'inline-flex',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(0, hasCloseIcon ? 1.5 : 2, 0, 2),
  width: isBanner ? '100%' : 'unset',
  border: 'none',
  boxShadow: `inset 0 0 0 1px ${theme.palette.divider}`,
  justifyContent: isBanner ? 'space-between' : 'flex-start',
  maxWidth,
  [`& .${noteClasses.content}`]: {
    display: 'flex'
  },
  [`& .${noteClasses.icon}`]: {
    marginRight: theme.spacing(2),
    padding: theme.spacing(1.5, 0),
    display: 'flex',
    alignSelf: 'baseline'
  },
  [`& .${noteClasses.message}`]: {
    padding: theme.spacing(1.5, 0)
  },
  [`& .${noteClasses.variant}`]: {
    display: 'inline'
  },
  [`& .${noteClasses.action}`]: {
    padding: theme.spacing(1.5, 0),
    paddingLeft: theme.spacing(2),
    display: 'flex',
    alignSelf: 'flex-start',
    color: theme.palette.grey[500],
    [`& .${muiIconButtonClasses.root}`]: {
      padding: theme.spacing(0.25),
      '&:hover': {
        background: theme.palette.action.hover
      }
    }
  }
}));
